// let urlbase  = 'http://43.137.41.66:8044';
// let urlbase  = 'http://192.168.10.188:8044';
// let urlbase  ='http://1.13.18.50:8044';
let urlbase = process.env.VUE_APP_BASE_API;
// let urlbase  ='https://esmtapi.festiot.online/';
export default urlbase
